<template>
  <div class="loading-spinner" :style="spinnerStyle">
    <svg class="spinner" viewBox="0 0 50 50">
      <circle
        class="path"
        :stroke="colorValue"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="5"
      />
    </svg>
  </div>
</template>

<script lang="ts" setup>

// INTERFACES

interface LoadingProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  height?: string;
  width?: string;
}

// PROPS

const props = withDefaults(defineProps<LoadingProps>(), {
  color: 'primary',
  size: 'medium',
  height: 'auto',
  width: 'auto',
});

// CONSTANTS

const sizeMap = {
  small: '20px',
  medium: '50px',
  large: '100px'
};

// COMPUTEDS

const colorValue = computed(() => resolvedColor(props.color));

const spinnerStyle = computed(() => {
  const spinnerSize = sizeMap[props.size || 'medium'];

  return {
    width: props.width === 'auto' ? spinnerSize : props.width,
    height: props.height === 'auto' ? spinnerSize : props.height,
  };
});

</script>

<style scoped>
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
}
.spinner {
  animation: rotate 2s linear infinite;
  transform-origin: center;
}
.path {
  stroke-linecap: round;
  animation: dash 1.5s ease-in-out infinite;
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
</style>
